import { Table } from "@mantine/core";
import { StyledTd, StyledTh } from "src/styled";

const PreTextTable = ({ tableObject }: { tableObject: any }) => {
  const renderHeaders = () => {
    return tableObject.headers.map((header: any, index: number) => {
      return <StyledTh key={index}>{header}</StyledTh>;
    });
  };

  const renderRows = () => {
    return tableObject.rows.map((row: any, i: number) => {
      const rowToRender = row.map((rowItem: any, j: number) => {
        return (
          <StyledTd key={j} center>
            {rowItem}
          </StyledTd>
        );
      });
      return <tr key={i}>{rowToRender}</tr>;
    });
  };

  return (
    <Table style={{ pageBreakInside: "avoid" }}>
      {renderHeaders()}
      {renderRows()}
    </Table>
  );
};

export default PreTextTable;
